export const enum ProtocolEnum {
    HTTP = 'http://',
    HTTPS = 'https://',
}
